import { quizResources } from '@packages/shared/simple-simple-registration/components/quiz/resources';

export { default } from '@packages/shared/simple-simple-registration/components/quiz/SimpleRegistrationQuiz';

export type StaticProps = {
  params: {
    id: string;
  };
};

export const getStaticProps = (context: StaticProps) => {
  return { props: { pageId: context.params.id } };
};

export function getStaticPaths() {
  const paths = Object.values(quizResources.steps).map((step) => ({
    params: { id: step.id },
  }));

  return { paths, fallback: false };
}
